import { Box, CircularProgress, Typography } from '@mui/material';

export function PageLoader() {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center', 
        justifyContent: 'center',
        minHeight: '400px',
        gap: 2
      }}
    >
      <CircularProgress size={40} />
      <Typography variant="body2" color="text.secondary">
        Se incarca...
      </Typography>
    </Box>
  );
}
